/* Editorial marquee — fresh leaf-green strip, cream text */

const ITEMS = [
  "High Plant Protein",
  "Zero Refined Flour",
  "100% Farm Sourced",
  "Natural Fiber",
  "Clean Label",
  "No Preservatives",
  "Sprouted Pulses",
  "Made For India",
];

const DOT = (
  <span className="mx-5 text-xs" style={{ color: "#9FCBAA" }} aria-hidden="true">
    ✦
  </span>
);

export default function MarqueeStrip() {
  const track = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-strip"
      className="w-full overflow-hidden py-4 select-none"
      style={{ backgroundColor: "#2F6B3F" }}
      aria-hidden="true"
    >
      <div className="marquee-track">
        {track.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span
              className="text-[11px] font-bold uppercase tracking-[0.24em] whitespace-nowrap"
              style={{ color: "rgba(250,247,242,0.92)" }}
            >
              {item}
            </span>
            {DOT}
          </span>
        ))}
      </div>
    </div>
  );
}
